import React from 'react'
import { useDevice } from 'hooks/useDevice'
import { Icon, IconName, IconProps } from 'ui/components/Icon'

import { BoxProps } from '../Box/Box'
import { Stack } from '../Stack/Stack'

type RoundIconButtonProps = {
    icon: IconName
    label: string
    onClick?: (e: React.MouseEvent) => void
    iconColor?: BoxProps['color']
    disabled?: boolean
    /** Size of the button - defaults to 'x5' */
    size?: BoxProps['width']
    /** Size of the icon - defaults to 'square_sm' */
    iconSize?: IconProps['size']
    /** Tint color of the button - defaults to undefined */
    tint?: BoxProps['tint']
} & Pick<BoxProps, 'background' | 'boxShadow'>

/**
 * Circular icon button for action buttons (mute, leave, etc.)
 */
export const RoundIconButton = React.memo(function RoundIconButton(props: RoundIconButtonProps) {
    const {
        icon,
        label,
        onClick,
        background = 'level2',
        tint,
        iconColor = 'default',
        boxShadow,
        disabled,
        size = 'x5',
        iconSize = 'square_sm',
    } = props
    const { isTouch } = useDevice()

    return (
        <Stack
            centerContent
            hoverable={!disabled}
            as="button"
            rounded="md"
            width={size}
            height={size}
            background={background}
            tint={tint}
            boxShadow={boxShadow}
            cursor={disabled ? 'default' : 'pointer'}
            aria-label={label}
            tooltip={isTouch ? undefined : label}
            style={{ opacity: disabled ? 0.5 : undefined }}
            onClick={disabled ? undefined : onClick}
        >
            <Icon type={icon} size={iconSize} color={iconColor} />
        </Stack>
    )
})
